var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-timepicker',{attrs:{"input-width":"100%"},model:{value:(_vm.item.endAt),callback:function ($$v) {_vm.$set(_vm.item, "endAt", $$v)},expression:"item.endAt"}})
}
var staticRenderFns = []

export { render, staticRenderFns }